var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"flandre",style:(_vm.position),attrs:{"alt":"Flandre","src":require("@/assets/flandre.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }